import { createMuiTheme } from "@material-ui/core";
import { Drawer, Grid, styled } from "@mui/material";
import React, { useRef, useState } from "react";

import AttachmentCaptionDrawer from "../../pages/comments/attachmentCaptionDrawer";
import DropzoneCommentFile from "../dropzone/DropzoneCommentFile";
import DropzoneCommentImage from "../dropzone/DropzoneCommentImage";

const attachmentPaperStyle = createMuiTheme({
  overrides: {
    MuiDrawer: {
      paper: {
        background: "#fff",
      },
    },
  },
});

interface Props {
  attachmentDrawer: boolean;
  setAttachmentDrawer: (attachmentDrawer: boolean) => any;
  referenceKey: string;
  mentionUsers: any;
  setRefreshOnSendCap?: any;
}

const CustomizedDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    background: rgb(0, 16, 38) !important;
    bottom: 50px;
    right: auto;
    margin: 5px 20px;
    height: 100px;
    width: 430px !important;
    overflow-x: hidden;
    border-radius: 8px;
    z-index: 500;
    // border: 2px solid #01af43;
  }
`;
export type fileType = "file" | "image" | "none";

const AttachmentDrawer = ({
  setAttachmentDrawer,
  attachmentDrawer,
  referenceKey,
  mentionUsers,
  setRefreshOnSendCap,
}: Props) => {
  const [attachmentCaptionDrawer, setAttachmentCaptionDrawer] = useState(false);
  const [choosedImgSrc, setChoosedImgSrc] = useState<any>();
  const [choosedImgCropperSrc, setChoosedImgCropperSrc] = useState("");
  const [choosedFileSrc, setChoosedFileSrc] = useState<string[]>([]);
  const [isFile, setIsFile] = useState<fileType>("none");
  const [isEditBtnDisable, setEditBtnDisable] = useState(false);

  function handleOnFileChoosed(files: any) {
    setChoosedFileSrc(files);
  }
  function handleOnImageChoosed(files: any) {
    setChoosedImgSrc(files);
    setChoosedImgCropperSrc(files[0].preview);
  }
  let refDropZoneImage = useRef(null);
  let refDropZoneFile = useRef(null);

  const funcRefImage = (e: any) => {
    e.current.click();
  };
  const funcRefFile = (e: any) => {
    e.current.click();
  };
  return (
    <div>
      <CustomizedDrawer
        disableEnforceFocus
        anchor="bottom"
        open={attachmentDrawer}
        onClose={() => setAttachmentDrawer(false)}
        style={attachmentCaptionDrawer ? { display: "none" } : {}}
      >
        <Grid
          container
          justifyContent={"space-around"}
          alignItems={"center"}
          height={"100%"}
        >
          <Grid
            item
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              setAttachmentCaptionDrawer(true);
              setIsFile("image");
              // imageRef.current.click();
            }}
          >
            <DropzoneCommentImage
              onFileChoosed={handleOnImageChoosed}
              funcRefImage={funcRefImage}
              refDropZone={refDropZoneImage}
            />
          </Grid>
          <Grid
            item
            sx={{
              cursor: "pointer",
            }}
            onClick={() => {
              setIsFile("file");
              setAttachmentCaptionDrawer(true);
              // fileRef.current.click();
            }}
          >
            <DropzoneCommentFile
              onFileChoosed={handleOnFileChoosed}
              funcRefFile={funcRefFile}
              refDropZone={refDropZoneFile}
            />
          </Grid>
        </Grid>
      </CustomizedDrawer>

      <AttachmentCaptionDrawer
        setChoosedImgSrc={setChoosedImgSrc}
        attachmentCaptionDrawer={attachmentCaptionDrawer}
        setAttachmentCaptionDrawer={setAttachmentCaptionDrawer}
        choosedImgSrc={choosedImgSrc}
        choosedImgCropperSrc={choosedImgCropperSrc}
        setChoosedImgCropperSrc={setChoosedImgCropperSrc}
        setChoosedFileSrc={setChoosedFileSrc}
        choosedFileSrc={choosedFileSrc}
        isFile={isFile}
        isEditBtnDisable={isEditBtnDisable}
        setEditBtnDisable={setEditBtnDisable}
        referenceKey={referenceKey}
        mentionUsers={mentionUsers}
        setAttachmentDrawer={setAttachmentDrawer}
        setRefreshOnSendCap={setRefreshOnSendCap}
        funcRefImage={funcRefImage}
        funcRefFile={funcRefFile}
        refDropZoneImage={refDropZoneImage}
        refDropZoneFile={refDropZoneFile}
      />
    </div>
  );
};

export default AttachmentDrawer;
